<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :items="list"
      sort-by="perno"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("FirstName"),
          value: "FirstName",
        },
        {
          text: this.$t("lastName"),
          value: "lastName",
        },
        {
          text: this.$t("DomainLoginName"),
          value: "DomainLoginName",
        },
        {
          text: this.$t("card-no"),
          value: "perno",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>